var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPiecesDegagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "mainStroke",
    id: "rep\\xE8re",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill-rule: evenodd;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.5.2C0,.6,0,.8.1,1.3c0,.2,2.8,3.5,6,7.5l5.8,7.1v18.3l-5.9,7.2C2.9,45.2.2,48.6.1,48.8c-.2.4,0,.8.5,1.1.3.2.4.2.6.1.1,0,2.9-3.4,6.2-7.4l6-7.3h23.1l6,7.3c3.3,4,6.1,7.4,6.2,7.4.2,0,.3,0,.6-.1.5-.3.7-.7.5-1.1,0-.2-2.8-3.5-6-7.5l-5.9-7.2V15.9l5.9-7.2c3.2-3.9,5.9-7.3,6-7.5.2-.4,0-.8-.5-1.1-.3-.2-.4-.2-.6,0-.1,0-2.9,3.4-6.2,7.4l-6,7.3H13.4l-6-7.3C4.2,3.5,1.4.2,1.3.1,1,0,.9,0,.5.2M36,25v8.4h-3s-3,0-3,0v-7.3c-.1-7-.1-7.3-.3-7.4-.3-.2-8.9-.2-9.3,0-.2.1-.2.4-.3,7.4v7.3c0,0-3.1,0-3.1,0h-3s0-16.9,0-16.9h22v8.4M28.1,26.8v6.4h-6.1v-6.4s0-6.4,0-6.4h6.2v6.4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPiecesDegagement);
export default __webpack_public_path__ + "static/media/pieces_Degagement.6c65c0bb299139d35428f2e3fb3f1954.svg";
export { ForwardRef as ReactComponent };